var map = {
	"./bg.png": "36e1",
	"./footer.png": "5f32",
	"./game/1-1.png": "d779",
	"./game/1-2.png": "1e67",
	"./game/1-3.png": "16e1",
	"./game/1-4.png": "bb1f",
	"./game/2-1.png": "5f36",
	"./game/2-2.png": "1179",
	"./game/2-3.png": "21a8",
	"./game/2-4.png": "66f8",
	"./game/3-1.png": "5d30",
	"./game/3-2.png": "e49a",
	"./game/3-3.png": "4be8",
	"./game/3-4.png": "61c9",
	"./game/4-1.png": "3c51",
	"./game/4-2.png": "4b48",
	"./game/4-3.png": "5c01",
	"./game/4-4.png": "4bc7",
	"./game/5-1.png": "e9a6",
	"./game/5-2.png": "e19e",
	"./game/5-3.png": "a4e6",
	"./game/5-4.png": "d8c6",
	"./hardware/1-1.png": "4414",
	"./hardware/1-2.png": "b386",
	"./hardware/1-3.png": "cea1",
	"./hardware/1-4.png": "0e16",
	"./hardware/2-1.png": "6e84",
	"./hardware/2-2.png": "a959",
	"./hardware/2-3.png": "76ad",
	"./hardware/2-4.png": "e9d8",
	"./hardware/3-1.png": "6521",
	"./hardware/3-2.png": "4c10",
	"./hardware/3-3.png": "0737",
	"./hardware/3-4.png": "bab9",
	"./hardware/4-1.png": "5fa9",
	"./hardware/4-2.png": "301d",
	"./hardware/4-3.png": "4fe2",
	"./hardware/4-4.png": "84125",
	"./hardware/5-1.png": "3bec",
	"./hardware/5-2.png": "eef7",
	"./hardware/5-3.png": "e8f0",
	"./hardware/5-4.png": "674a",
	"./hardware/6-1.png": "ddc8",
	"./hardware/6-2.png": "82e3",
	"./hardware/6-3.png": "0a64",
	"./hardware/6-4.png": "c3ca",
	"./industry/1-1.png": "c514",
	"./industry/1-2.png": "e9f7",
	"./industry/1-3.png": "07ea",
	"./industry/1-4.png": "d70c",
	"./industry/2-1.png": "8ffa",
	"./industry/2-2.png": "84a7",
	"./industry/2-3.png": "e032",
	"./industry/2-4.png": "6009",
	"./industry/3-1.png": "3f41",
	"./industry/3-2.png": "c9ed",
	"./industry/3-3.png": "3b0f",
	"./industry/3-4.png": "78c2",
	"./industry/4-1.png": "79a1",
	"./industry/4-2.png": "526f",
	"./industry/4-3.png": "4b78",
	"./industry/4-4.png": "0309",
	"./industry/5-1.png": "8096",
	"./industry/5-2.png": "b4af",
	"./industry/5-3.png": "4bc4",
	"./industry/5-4.png": "254f",
	"./line_bg0.png": "01ae",
	"./line_bg1.png": "76f1",
	"./t1.png": "3aa7",
	"./t1_ok.png": "633a",
	"./t2.png": "5c81",
	"./t2_ok.png": "902c",
	"./t3.png": "87b4",
	"./t3_ok.png": "fe70",
	"./tab_bg.png": "a1dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebbb";